var components = {
  'application'         : 'application',
  'landing'             : 'landing',
  'checkout'            : 'checkout',
  'ty'                  : 'ty',
  'text-landing'        : 'textlanding',
  'video-landing'       : 'videolanding',
  'program-info'        : 'programinfo',
  'webinar'             : 'webinar',
  'webinar-column'      : 'webinarcolumn',
  'webinar-partner'     : 'webinarpartner',
  'webinar-replay'      : 'webinarreplay',
  'webinar-custom'      : 'webinarcustom',
  'webinar-ty'          : 'webinarty',
  'custom'              : 'custom',
  'blank'               : 'blank'
}

export default components;
